/**
 * Browser SpeechRecognition helpers for Collaborate dictation.
 */

export type DictateResultLike = {
  readonly isFinal: boolean;
  readonly length: number;
  [index: number]: { transcript: string } | undefined;
};

export type DictateResultsLike = {
  readonly length: number;
  readonly resultIndex?: number;
  [index: number]: DictateResultLike | undefined;
};

/** Append dictated text to the composer base, inserting a space when needed. */
export function joinDictate(base: string, chunk: string): string {
  const next = chunk.trim();
  if (!next) return base;
  if (!base) return next;
  return /\s$/.test(base) ? `${base}${next}` : `${base} ${next}`;
}

/**
 * Fold a SpeechRecognition result batch into final + interim chunks.
 * Finals are committed into `base`; interim is preview-only.
 */
export function foldDictateResults(
  base: string,
  results: DictateResultsLike,
  resultIndex = 0,
): { base: string; text: string } {
  let nextBase = base;
  let interimChunk = '';
  const start = Math.max(0, resultIndex);
  for (let i = start; i < results.length; i++) {
    const result = results[i];
    const transcript = result?.[0]?.transcript ?? '';
    if (result?.isFinal) {
      nextBase = joinDictate(nextBase, transcript);
    } else {
      interimChunk += transcript;
    }
  }
  return {
    base: nextBase,
    text: joinDictate(nextBase, interimChunk),
  };
}
